var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCart01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visa_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 405.6 284.8",
    style: {
      enableBackground: "new 0 0 405.6 284.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\t.st0 {\r\n\t\t\tfill: none;\r\n\t\t\tstroke: #FFFFFF;\r\n\t\t\tstroke-width: 4;\r\n\t\t}\r\n\r\n\t\t.st12 {\r\n\t\t\tfill: none;\r\n\t\t\tstroke: #FFFFFF;\r\n\t\t\tstroke-width: 4;\r\n\t\t\tstroke-linecap: round;\r\n\t\t\tstroke-linejoin: round;\r\n\t\t}\r\n\r\n\t\t.st2 {\r\n\t\t\tfill: #FFFFFF;\r\n\t\t}\r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "visa"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M358.1,259H47.3c-13.8,0-25-11.2-25-25V51.7c0-13.8,11.2-25,25-25h310.8c13.8,0,25,11.2,25,25V234 C383.1,247.8,371.9,259,358.1,259z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 22.3,
    y1: 85.6,
    x2: 383.1,
    y2: 85.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 383.1,
    y1: 125.1,
    x2: 22.3,
    y2: 125.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 53.3,
    y1: 186.2,
    x2: 97.4,
    y2: 186.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 53.3,
    y1: 215.7,
    x2: 149.3,
    y2: 215.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "288.1,193.5 280.6,228 289.7,228 297,193.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M274.9,193.5l-9.3,23.4l-3.9-20c-0.5-2.3-2.3-3.4-4.1-3.4h-15.2l-0.2,0.9c3.2,0.7,6.6,1.8,8.9,3 c1.4,0.7,1.6,1.4,2,3l7.1,27.5h9.6l14.6-34.6h-9.3V193.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M345.7,193.5h-7.7c-1.8,0-3.2,0.9-3.9,2.5L320.7,228h9.3l1.8-5.2h11.4l1.1,5.2h8.2L345.7,193.5z M334.8,215.7 l4.8-13l2.7,13H334.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M308.8,203c0-1.1,1.1-2.5,3.9-3c1.4-0.2,4.8-0.2,8.9,1.6l1.6-7.3c-2-0.7-5-1.6-8.4-1.6c-8.9,0-15,4.8-15,11.4 c0,5,4.5,7.7,7.7,9.3c3.4,1.6,4.5,2.7,4.5,4.3c0,2.3-2.7,3.4-5.5,3.4c-4.5,0-7.1-1.1-9.1-2.3l-1.6,7.5c2,0.9,5.9,1.8,10,1.8 c9.3,0,15.5-4.5,15.5-11.8C321.3,207.8,308.6,207.1,308.8,203z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart01);
export default __webpack_public_path__ + "static/media/cart-01.4fdf383d8e61e73ec0579fe787942621.svg";
export { ForwardRef as ReactComponent };